import React, { useReducer } from 'react';
import axios from 'axios';
import AppContext from './appContext';
import AppReducer from './appReducer';
import {
GET_POSTS,
SEARCH_POSTS,
SET_LOADING,
SET_READMORE_LOADING,
LOAD_MORE_POSTS,
GET_FILTRED_POSTS,
SET_ORDER
} from '../types';

const AppState = (props) => {
  const { api, baseUrl, currentLanguage, postType, taxonomies, postsPerPage, maxPages, translations, queryParams } = props;

  if(!api || !postType) {
    return null;
  }

  const initialState = {
    postType: postType,
    api: api,
    baseUrl: baseUrl,
    posts: [],
    loading: false,
    readMoreloading: false,
    taxonomies: taxonomies,
    translations: translations,
    maxPages: (maxPages) ? maxPages : '',
    foundPosts: '',
    queryParams : queryParams,
    params: {
      searchStr: (queryParams.searchStr) ? queryParams.searchStr : '',
      page: (queryParams.page) ? queryParams.page : 1,
      count: (queryParams.count) ? queryParams.count : postsPerPage,
      sortOrder: (queryParams.sortOrder) ? queryParams.sortOrder : 'latest',
      lang: currentLanguage
    }
  }

  if (postType === 'asset') {
    initialState.params.sortOrder = 'alphabetical';
  }

  const queryParamTaxonomies = [
    'year',
    'news_category',
    'news_subject',
    'asset_category',
    'asset_type',
    'toolbox_product-group',
    'toolbox_activity',
    'toolbox_value',
    'toolbox_tags',
  ];

  queryParamTaxonomies.forEach((taxonomy, index) => {
    if(queryParams.hasOwnProperty(taxonomy)) {
      const name = taxonomy.replace('_', '-');
      const values = queryParams[taxonomy].split(',');
      initialState.params[name] = values;
    }
  });


  const [state, dispatch] = useReducer(AppReducer, initialState);

  //Get posts
  const getPosts = async () => {
    setLoading();

    const url = `${api}/${postType}`;
    const res = await axios.get(url, {
      params: state.params
    });


    dispatch({
      type: GET_POSTS,
      payload: res.data.posts,
      maxPages: res.data.max_num_pages,
      foundPosts: res.data.found_posts,
    });
  };

  //Search posts
  const searchPosts = async searchTxt => {
    setLoading();

    // console.log(searchTxt);

    state.params.page = 1;
    state.params.searchStr = searchTxt;

    const url = `${api}/${postType}`;
    const res = await axios.get(url, {
      params: state.params
    });

    dispatch({
      type: SEARCH_POSTS,
      payload: res.data.posts,
      maxPages: res.data.max_num_pages,
      foundPosts: res.data.found_posts,
    });
  };

  //Load more posts
  const loadMorePosts = async pageNr => {
    setReadmoreLoading();

    state.params.page = pageNr;

    const url = `${api}/${postType}`;
    const res = await axios.get(url, {
      params: state.params
    });

    dispatch({
      type: LOAD_MORE_POSTS,
      payload: res.data.posts,
      maxPages: res.data.max_num_pages,
      foundPosts: res.data.found_posts,
    });
  };

  //Get filtred posts
  const getFiltredPosts = async (name, value) => {
    setLoading();

    // console.log(value);
    state.params.page = 1;

    if(name === 'year') {
      state.params.year = value;
    } else {
      state.params[name] = value;
    }

    const url = `${api}/${postType}`;
    const res = await axios.get(url, {
      params: state.params
    });

    dispatch({
      type: GET_FILTRED_POSTS,
      payload: res.data.posts,
      maxPages: res.data.max_num_pages,
      foundPosts: res.data.found_posts,
    });
  };

  //Set order
  const setOrder = async (value) => {
    setLoading();

    state.params.sortOrder = value;

    const url = `${api}/${postType}`;
    const res = await axios.get(url, {
      params: state.params
    });

    dispatch({
      type: SET_ORDER,
      payload: res.data.posts,
      maxPages: res.data.max_num_pages,
      foundPosts: res.data.found_posts,
    });
  };

  //Set loading
  const setLoading = () => dispatch({ type: SET_LOADING });
  const setReadmoreLoading = () => dispatch({ type: SET_READMORE_LOADING });

  return <AppContext.Provider
    value={{
      api: state.api,
      baseUrl: state.baseUrl,
      postType: state.postType,
      queryParams: state.queryParams,
      posts: state.posts,
      loading: state.loading,
      readMoreloading: state.readMoreloading,
      taxonomies: state.taxonomies,
      translations: state.translations,
      maxPages: state.maxPages,
      foundPosts: state.foundPosts,
      params: state.params,
      getPosts,
      searchPosts,
      loadMorePosts,
      getFiltredPosts,
      setOrder
    }}
  >
    {props.children}
  </AppContext.Provider>
}

export default AppState;



// WEBPACK FOOTER //
// ./src/context/app/AppState.js